export const STOLT_CONST = Object.freeze({
  SUCCESS_STATUS: 'success',

});

export const RELATIONSHIP_DOC_LABEL = Object.freeze({
  'EXWIFE': 'Annulment document',
  'XWIFE': 'Annulment document',
  'WIFE': 'Marriage certificate',
  'HUSBAND': 'Marriage certificate',
  'DAUGHTER': 'Birth certificate',
  'SON': 'Birth certificate',
  'LEGALGUAR': 'Legal guardian document',
  'LEGALGUARD': 'Legal guardian document',
});



export const MANDATORY_ATTACHMENT_RELATIONSHIP = Object.freeze({
  'EXWIFE': 'Annulment document',
  'XWIFE': 'Annulment document',
  'WIFE': 'Annulment document',
  'HUSBAND': 'Annulment document'
});


export const NOTIFICATION_MESSAGE = Object.freeze({
  FILE_SIZE_EXCEEDS: 'The file size exceeds the maximum allowed limit of 5MB. Please upload a smaller file.',
  FILE_SUPPORT_FORMET: 'Supported file format only JPEG, PNG or PDF.',
  ALL_FILE_SUPPORT_FORMET: 'Supported file format only XLS, JPEG, PNG or PDF.',
  FILE_SUPPORT_FORMET_XLS: 'Supported file format only XLS.',
  FILE_SUPPORT_FORMET_EXCEPT_PDF: 'Supported file format only JPEG, PNG.',
  DOCUMENT_LIMIT_EXCEED: 'Only 3 files are allowed.',
  ALLOTMENT_LIMIT_EXCEED: 'Only 2 beneficiaries are allowed.',
  FILIPINO_ALLOTMENT_LIMIT_EXCEED: 'Only 3 allotment beneficiaries are allowed.',
  BOW_LIMIT_EXCEED: 'Only 1 BOW beneficiary are allowed.',
  BENEFICIARY_SAVED_SUCCESS:'Your beneficiary was saved successfully.',
  BENEFICIARY_SUBMITTED_SUCCESS:"Your beneficiaries were submitted for approval.",
  BENEFICIARY_ONE_SUBMITTED_SUCCESS:"Your beneficiary was submitted for approval.",
  BENEFICIARY_REVERT_SUCCESS: 'Your changes have been reverted successfully.',
  FAMILY_REVERT_SUCCESS: 'Your family member was restored to the last approved version.',
  DRAFT:"Your details were saved successfully.",
  PENDING_APPROVAL:"Your details were saved and submitted for approval.",
  FEEDBACK_SURVEY_SUBMITTED_SUCCESS:"360 feedback submitted successfully.",
  SURVEY_SUBMITTED_SUCCESS:"Survey submitted successfully.",
  FEEDBACK_SURVEY_SAVED_SUCCESS:"360 feedback saved successfully.",
  SURVEY_SAVED_SUCCESS:"Survey saved successfully.",
  UPLOAD_LIMIT_EXCEED: 'Only 1 file is allowed.',
  NOT_ENOUGH_BALANCE:"Insufficient expense balance due to prior commitments; add new expenses after receiving more cash.",
  NOT_ENOUGH_BALANCE_CASH_ADVANCE:"Cash advance unavailable due to insufficient balance; available once enough ship cash is received.",
  HIGH_SCHOOL_ALLOWANCE:"You can request an allowance only between 01 April and 31 October for the current school year."
});


export const USER_STATUS = Object.freeze({
  APPROVED: 'Approved',
  PENDING_APPROVAL: 'Pending approval',
  REJECTED: 'Rejected',
  DRAFT: 'Draft',
  REQUESTE_FOR_DELETION:'Submitted for deletion',
  MARKED_FOR_DELETION:'Marked for deletion'
})

export const USER_BENEFICIARY = Object.freeze({
  FILIPINO_POOL_CODE:[13009],
  FILIPINO_ALLOTMENT_LIMIT:3,
  OTHER_ALLOTMENT_LIMIT:2
});

export const BENEVOLENT_FUND = Object.freeze({
   POOL_CODE:[13004,13013,13005,13009],
});

export const CASH_ADVANCE_LIMIT_POOL = Object.freeze({
  POOL_CODE:['13009'],
});

export const SUCCESS_MESSAGE = Object.freeze({
   DRAFT:"Your details were saved successfully.",
   PENDING_APPROVAL:"Your details were saved and submitted for approval.",
});
export const CASH_ORDER_SUCCESS_MESSAGE = Object.freeze({
   DRAFT:"Cash order draft request has been saved successfully.",
   DELETE:"Cash order draft request has been deleted successfully.",
   PENDING_APPROVAL:"Cash order request has been submitted successfully.",
   PORT_AGENT_APPROVAL:"Add port agent request has been submitted successfully.",
});
export const SLOP_CHEST_SUCCESS_MESSAGE = Object.freeze({
   SUBMITTED:"Slopchest item has been submitted successfully.",
   DELETE:"Slopchest item has been deleted successfully.",
   
});

export const CAM_EXPENSE_SUCCESS_MESSAGE = Object.freeze({
  DRAFT:"Expense item has been saved successfully.",
  DELETE:"Expense item has been deleted successfully.",
  PENDING_APPROVAL:"Expense item has been submitted successfully.",
});
export const CAMHospitality_SUCCESS_MESSAGE = Object.freeze({
  SUBMIT:"Hospitality item has been submitted successfully.",
  DELETE:"Hospitality item has been deleted successfully.",
});
export const CAM_CASH_APPROVAL_SUCCESS_MESSAGE = Object.freeze({
  APPROVED:"Cash request has been approved successfully",
  APPROVED_AND_RECEIVED:"Cash request has been approved  and received successfully",
  REJECTED:"Cash request has been rejected successfully",
  RECEIVED:"Cash request has been received successfully",
  MULTIPLE_APPROVED:(count:number) => `${count} requests has been approved successfully.`,
  MULTIPLE_APPROVED_AND_RECEIVED:(count:number) => `${count} requests has been approved  and received successfully.`,
  MULTIPLE_REJECTED:(count:number) => `${count} requests has been rejected successfully`,
  MULTIPLE_RECEIVED:(count:number) => `${count} requests has been received successfully`
});

export const BTN_TEXT = Object.freeze({
  SAVE_AS_DRAFT: 'Save as draft',
  CANCEL_DRAFT: 'Cancel draft',
  UPDATE_DRAFT: 'Update draft',
  SAVE_AND_SUBMIT: 'Save and submit',
  CANCEL: 'Cancel',
  CLOSE: 'Close',
  DELETE: 'Delete',
  SUBMITTING: 'Submitting...',
  SAVING_AND_SUBMITTING: 'Saving and submitting...',
  SAVING_AS_DRAFT: 'Saving as draft...',
});

export const DOCUMENTS_STATUS = Object.freeze({
  PENDING_APPROVAL: 'Pending approval',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  EXPIRED: 'Expired',
  DRAFT: 'Draft',
  IN_PROGRESS: 'In progress',
});

export const FEEDBACK_SURVEY_STATUS = Object.freeze({
  ACTIVE: 'Active',
  HISTORY: 'History',
});

export const EXPENSE_STATUS = Object.freeze({
  PENDING_APPROVAL: 'Pending approval',
  APPROVED: 'Approved',
  AWAITING_PROCESSING: 'Awaiting processing',
  REJECTED: 'Rejected',
  EXPIRED: 'Expired',
  DRAFT: 'Draft',
});

export const STATUS = Object.freeze({
  PENDING_APPROVAL: 'Pending approval',
  APPROVED: 'Approved',
  DRAFT: 'Draft',
  REJECTED: 'Rejected',
});
export const CASH_ORDER_STATUS = Object.freeze({
  PENDING_APPROVAL: 'Pending approval',
  APPROVED: 'Approved',
  DRAFT: 'Draft',
  REJECTED: 'Rejected',
  RECEIVED: 'Received',
});

export const CAM_EXPENSE_STATUS = Object.freeze({
  PENDING_APPROVAL: 'Pending approval',
  APPROVED: 'Approved',
  DRAFT: 'Draft',
  REJECTED: 'Rejected',
  RECEIVED: 'Received',
});

export const STATUS_SORT = Object.freeze({
  DATA: [STATUS.DRAFT,STATUS.REJECTED,STATUS.PENDING_APPROVAL,STATUS.APPROVED],
  
});

export const DOCUMENTS_TABS = Object.freeze([
    { key: 'IN_PROGRESS', value: 'In progress'},
    { key: 'APPROVED', value: 'Approved' },
    { key: 'REJECTED', value: 'Rejected' },
    { key: 'EXPIRED', value: 'Expired' }
]);

export const CAM_CURRENCY_LIST = Object.freeze([
  {'id': "USD",'name': "USD"},
  {'id': "GBP",'name': "GBP"},
  {'id': "EUR",'name': "EUR"}
]);

export const FEEDBACK_SURVEY_TABS = Object.freeze([
  { key: 'ACTIVE', value: 'Active'},
  { key: 'HISTORY', value: 'History' },
]);

export const EXPENSE_TABS = Object.freeze([
  { key: 'IN_PROGRESS', value: 'In progress'},
  { key: 'APPROVED', value: 'Approved' },
  { key: 'REJECTED', value: 'Rejected' },
  { key: 'EXPIRED', value: 'Expired' }
]);

export const PAYROLL_TABS = Object.freeze([
  { key: 'Expenses', value: 'Expenses'},
  { key: 'Cash advances', value: 'Cash advances' },
  { key: 'High school allowance', value: 'High school allowance' },
  { key: 'Benevolent fund', value: 'Benevolent fund' },
  { key: 'Payslips', value: 'Payslips' }
]);

export const CURRENCY_LIST = Object.freeze([
  { id: 'USD', value: 'USD', name: 'USD', symbol: '$' },
  { id: 'PHP', value: 'PHP', name: 'PHP', symbol: '₱' }
]);

export const USER_STATUS_LABEL = Object.freeze([
  { status: 'Approved', label: 'Approved on', filed: 'APPROVED_ON', edit: true},
  { status: 'Awaiting processing', label: 'Approved on', filed: 'APPROVED_ON', edit: true},
  { status: 'Draft', label: '',edit: false ,filed: 'REQUESTED_ON' },
  { status: 'Pending approval', label: 'Submitted on',edit: false , filed: 'REQUESTED_ON'},
  { status: 'Rejected', label: 'Rejected on',edit: true, filed: 'REQUESTED_ON' },
  { status: 'Submitted for deletion', label: 'Submitted on',edit: false, filed: 'REQUESTED_ON' },
  { status: 'Marked for deletion', label: 'Marked on',edit: true, filed: 'REQUESTED_ON' },
  { status: 'Marked for approval', label: 'Submitted on',edit: false , filed: 'REQUESTED_ON'},
  { status: 'Received', label: 'Received on',edit: false , filed: 'RECEIVED_ON'},
]);


export const INPUT_ERROR_MESSAGE = Object.freeze({
  CHARACTOR_ONLY: 'Special characters and numbers are not allowed.',
  NUMBER_ONLY: 'Only numeric values are allowed.',
  SPECIAL: 'Special characters are not allowed.',
  MAXLENGTH:'You have reached the maximum characters limit for this field.',
  MINLENGTH_ACCOUNT_CODE:'Enter exactly number digits.',
  MAX:'Amount exceeds the maximum allowed.',
  PERCENTAGE_DATA_FORMET:'Only 3 numbers and 2 decimals are allowed.',
  DECIMAL_DATA_FORMET:' Only 5 numbers and 2 decimals are allowed.',
  DECIMAL_DATA_FORMET_FOUR_NO:' Only 4 numbers and 2 decimals are allowed.',
  PERCENTAGE_MAX:'Please enter a value between 1% and 100%.',
  QUANTITY_MAX:'Please enter a value between 1 and 25.',
  NUMERIC_ONLY:'Decimal values are not allowed.',
  NUMERIC_SPECIAL_ALLOWED:'Only numbers and special characters are allowed.',
  HARMFUL_CHARACTERS_NOT_ALLOWED:'Special characters allowed, except < > ; | & = $',
  NUMERIC_SPECIAL_ALLOWED_EXCEPT_HARMFUL:'Only numbers and special characters are allowed, except < > ; | & = $',
})


export const DOCUMENT_CATEGORY_TYPE = {
  TRAVEL: "TRAVEL",
  MEDICAL: "MEDICAL",
  LICENSES: "LICENSES/CONTRACTS",
  TRAINING: "TRAINING",
};

export const DOCUMENT_DOC_TYPE = {
  "Travel": "travel",
  "Medical": "medical",
  'Licenses/Contracts': "licenses",
  "Training": "training",
   "Flag state": "flagstate"

};

export const MEDICAL_FIT_UNFIT_STATUS = {
  "FIT WITHOUT RESTRICTIONS": "FIT WITHOUT RESTRICTIONS",
  "UNFIT": "UNFIT",
  "FIT WITH RESTRICTIONS": "FIT WITH RESTRICTIONS",
  "NOT APPLICABLE": "NOT APPLICABLE"
};

export const MEDICAL_NEG_POS_STATUS = {
  NEGATIVE: "NEGATIVE",
  POSITIVE: "POSITIVE",
};

export const TRAVEL_DOC_TYPE = {
  PASSPORT: "PASSPORT",
  VISA: "VISA",
  VACCINATION: "VACC",
  SEAMANBOOK: "SBOOK"
}

export const TRAINING_INT_EXT_STATUS = {
  N: "INTERNAL",
  Y: "EXTERNAL"
};

export const VISA_ENTRY_TYPE = {
  "1 Entry": "1 Entry",
  "2 Entries": "2 Entries",
  "Multiple Entries": "Multiple Entries",
}

export const VISA_DURATION_TYPE = {
  "60 Days": "60 Days",
  "90 Days": "90 Days",
  "120 Days": "120 Days",
  "180 Days": "180 Days"
}

export const VISA_DURATION_MCV_TYPE = {
 "3 years": "3 years"
}


export const DOCUMENT_API_CONSTANT = {
  MEDICAL: "medical-type",
  TRAINING: "training-type",
  TRAVEL: "travel-list",
  LICENSES: "license-type",
  FALGSTATE: ""
}

export const EXPENSE_API_CONSTANT = {
  SIGN_ON_OFF: "SIGN_ON_OFF",
  MEDICAL_SAFETY: "MEDICAL_SAFETY",
  MEDICAL_CLAIM: "MEDICAL_CLAIM",
  TRAINING: "TRAINING",
  FALGSTATE: ""
}

interface DocumentCategoryDetails {
  key_code: string;
  key_desc: string;
}

export interface Rank{
  RANK_CODE: string;
  RANK_DESCRIPTION: string;
  _id:string
}

interface ExpenseCategoryDetails {
  key_code: string;
  key_desc: string;
}

export const DOCUMENT_CATEGORY_KEY_MAP: {
  [key: string]: DocumentCategoryDetails;
} = {
  MEDICAL: {
    key_code: 'MEDICALTYPE_CODE',
    key_desc: 'DESCRIPTION'
  },
  TRAINING: {
    key_code: 'TRAINING_CODE',
    key_desc: 'TRAINING_DESCRIPTION'
  },
  TRAVEL: {
    key_code: 'DOCCATEGORY_CODE',
    key_desc: 'DESCRIPTION'
  },
  LICENSES: {
    key_code: 'LICENSE_CODE',
    key_desc: 'LICENSE_DESCRIPTION'
  }
} as const;

export const EXPENSE_CATEGORY_KEY_MAP: {
  [key: string]: ExpenseCategoryDetails;
} = {
  SIGN_ON_OFF: {
    key_code: 'TYPE_CODE',
    key_desc: 'TYPE_NAME'
  },
  MEDICAL_SAFETY: {
    key_code: 'TYPE_CODE',
    key_desc: 'TYPE_NAME'
  },
  MEDICAL_CLAIM: {
    key_code: 'TYPE_CODE',
    key_desc: 'TYPE_NAME'
  },
  TRAINING: {
    key_code: 'TYPE_CODE',
    key_desc: 'TYPE_NAME'
  }
} as const;

// Define an interface for Document Fields
interface DocumentField {
  label: string;
  key: string;
  type: string;
  split: boolean;
  postion?: number; // Optional, since not all fields have this property
}

// Define an interface for Categories
type DocumentCategory = 'TRAVEL' | 'MEDICAL' | 'LICENSES' | 'TRAINING';

// Define an interface for Expense
type ExpenseCategory = 'SIGN_ON_OFF' | 'MEDICAL_SAFETY' | 'MEDICAL_CLAIM' | 'TRAINING';


type DocumentFieldType = {
  label: string;
  key: string;
  type: string;
  options?: any;
  split: boolean;
  formControlName?: string,
  position?: number;
  condition_on?: string;
  optionKey?: string;
  exclude?: string[];
  excludeKey?: string;
  required?: boolean// Add optional properties if they exist
};

type ExpenseFieldType = {
  label: string;
  key: string;
  type: string;
  options?: any;
  split: boolean;
  formControlName?: string,
  position?: number;
  condition_on?: string;
  optionKey?: string;
  exclude?: string[];
  excludeKey?: string;
  required?: boolean// Add optional properties if they exist
};

type DocumentFieldsMap = {
  [key in DocumentCategory]: {
    [key: string]: DocumentFieldType[];
  };
};

type ExpenseFieldsMap = {
  [key in ExpenseCategory]: {
    [key: string]: ExpenseFieldType[];
  };
};

export const NOTIFICATION_SECTION =  {
  PROFILE_SECTION: "Profile Section",
  FAMILY_SECTION: "Family Member Section",
  DOCUMENT_SECTION: "Document Section",
  EXPENSE_SECTION: "Expense Section",
  CASH_ADVANCE_SECTION: "Cash Advance Section",
  ONBOARD_CASH_ADVANCE_SECTION: "Onboard Cash Advance Section",
  BENEFICIARY_SECTION: "Beneficiary Section",
  PAYSLIP_SECTION: "Payslip Section",
  BENEVOLENT_SECTION:"Benevolent Section",
  ACTIVITY_SECTION: "Activity Section",
  FORM_SECTION: "Form Section",
  HIGH_SCHOOL_ALLOWANCE_SECTION: "High School Allowance Section"
}

// Define the DOCUMENT_FIELDS constant with the appropriate type

export const ADD_DOCUMENT_FIELDS: any = {
  TRAVEL: {
    PASS: [
      { label: 'Passport number', required: true, key: 'DOC_NO', type: "string", split: false, errorType:'maxlength',maxLength:25},
      { label: 'Issued country', required: true, key: 'COUNTRY_CODE', type: "select-child", split: false , showSearchBar : true },
      { label: 'Issued date', required: true, key: 'ISSUE_DATE', type: "date", split: false },
      { label: 'Expiry date', required: true, key: 'EXPIRE_DATE', type: "date", split: false }
    ],
    SBOOK: [
      { label: "Seaman's document type", required: true, key: 'SUB_TYPE_CODE', type: "select-child", options: [], split: false, showSearchBar : false },
      { label: 'Document number', required: true, key: 'DOC_NO', type: "string", split: false, errorType:'maxlength',maxLength:25 },
      { label: 'Issued country', required: true,key: 'COUNTRY_CODE', type: "select-child", split: false, showSearchBar : true },
      { label: 'Issued date', required: true,key: 'ISSUE_DATE', type: "date", split: false },
      { label: 'Expiry date', required: true, key: 'EXPIRE_DATE', type: "date", split: false, condition_on: 'NO_EXPIRY' },
      { label: 'Issued permanently', key: 'NO_EXPIRY', type: "checkbox", split: false },
     
    ],
    VISA: [
      { label: 'Visa type', key: 'SUB_TYPE_CODE',required: true, type: "select-child", options: [], split: false, showSearchBar : false },
      { label: 'Visa entry', key: 'VISA_ENTRY', type: "select",options:VISA_ENTRY_TYPE, split: true, exclude: ['VISA-C1/D', 'VISA-B1/B2', 'OTHER','VISA'], excludeKey: 'SUB_TYPE_CODE' ,showSearchBar : false},
      { label: 'Visa duration', key: 'VISA_DURATION', options:[], type: "select-child", split: true, exclude: ['VISA-C1/D', 'VISA-B1/B2', 'OTHER', 'VISA'], excludeKey: 'SUB_TYPE_CODE' ,showSearchBar : false},
      { label: 'Visa number', key: 'DOC_NO',required: true, type: "string", split: false, errorType:'maxlength',maxLength:25 },
      { label: 'Visa country', key: 'COUNTRY_CODE',required: true, type: "select-child", options: [], split: false,showSearchBar : true },
      { label: 'Issued country', key: 'VISADOC_COUNTRY',required: true, type: "select-child", options: [], split: false,showSearchBar : true },
      { label: 'Issued date', key: 'ISSUE_DATE',required: true, type: "date", split: false },
      { label: 'Expiry date', key: 'EXPIRE_DATE',required: true, type: "date", split: false },
    ],
    VACC: [
      { label: "Vaccination type", required: true,key: 'SUB_TYPE_CODE', type: "select-child", options: [], split: false, showSearchBar : false },
      { label: 'Comments', key: 'COMMENTS',required: false, type: "string", split: true, exclude: ['VACCYF'], excludeKey: 'SUB_TYPE_CODE' },
      { label: 'Issued date', key: 'ISSUE_DATE',required: true, type: "date", split: false },
      { label: 'Expiry date', key: 'EXPIRE_DATE', required: true,type: "date", split: false, condition_on: 'NO_EXPIRY' },
      { label: 'Issued permanently', key: 'NO_EXPIRY', type: "checkbox", split: false },
    ]
  },
  MEDICAL: {
    PREEMPL: [
      { label: 'Fit/Unfit',required: true, key: 'FITUNIT', type: "select", options: MEDICAL_FIT_UNFIT_STATUS, split: true, showSearchBar : false },
      { label: 'Issued date', key: 'ISSUE_DATE',required: true, type: "date", split: false },
      { label: 'Expiry date', key: 'EXPIRE_DATE',required: true, type: "date", split: false },
      { label: 'Comments (optional)', key: 'COMMENTS', type: "textarea", split: false }
    ],
    DRUGALCO: [
      { label: 'Positve Negative',required: true, key: 'COMMENTS', type: "select", options: MEDICAL_NEG_POS_STATUS, split: true, showSearchBar : false },
      { label: 'Issued date', required: true,key: 'ISSUE_DATE', type: "date", split: false },
      { label: 'Expiry date', required: true,key: 'EXPIRE_DATE', type: "date", split: false }
    ],
    SUPPMED: [
      { label: 'Fit/Unfit', required: true,key: 'FITUNIT', type: "select", options: MEDICAL_FIT_UNFIT_STATUS, split: true, showSearchBar : false },
      { label: 'Issued date', required: true,key: 'ISSUE_DATE', type: "date", split: false },
      { label: 'Expiry date', required: true,key: 'EXPIRE_DATE', type: "date", split: false },
      { label: 'Comments (optional)', key: 'COMMENTS', type: "textarea", split: false }

    ]
  },
  LICENSES: {
    FORM: [
      { label: 'Number', required: true,key: 'DOC_NO', type: "string", split: false, errorType:'maxlength',maxLength:25},
      { label: 'Issued at',required: true, key: 'ISSUE_AT', type: "select-child", options: [], split: false, showSearchBar : true },
      { label: 'Issued by (optional)', key: 'ISSUE_BY', type: "string", split: false },
      { label: 'Issued date',required: true, key: 'ISSUE_DATE', type: "date", split: false },
      { label: 'Expiry date', required: true,key: 'EXPIRE_DATE', type: "date", split: false, condition_on: 'NO_EXPIRY' },
      { label: 'Issued permanently',required: false, key: 'NO_EXPIRY', type: "checkbox", split: false },
    ]
  },
  TRAINING: {
    FORM: [
      { label: 'Number', required: true,key: 'DOC_NO', type: "string", split: false, errorType:'maxlength',maxLength:25},
      { label: 'Start date',required: true, key: 'START_DATE', type: "date", split: false },
      { label: 'End date',required: true, key: 'END_DATE', type: "date", split: false },
      { label: 'Expiry date',required: true, key: 'EXPIRE_DATE', type: "date", split: false, condition_on: 'NO_EXPIRY' },
      { label: 'Issued permanently',required: false, key: 'NO_EXPIRY', type: "checkbox", split: false },
      { label: 'Internal or external',required: true, key: 'INTERNAL', type: "select", options: TRAINING_INT_EXT_STATUS, split: false, showSearchBar : false },
      { label: 'Conducted at (optional)', key: 'CONDUCT_AT', type: "select-child", options: [], split: false, showSearchBar : true },
    ]
  }

};

export const DOCUMENT_FIELDS = Object.freeze({
  TRAVEL: {
     PASS:[
        {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
        {label:'Type',key:'DOCTYPE_NAME',type:"string",split:false},
        {label:'Passport number',key:'DOC_NO',type:"string",split:false, errorType:'maxlength',maxLength:25},
        {label:'Issued country',key:'COUNTRY_NAME',type:"string",split:false},
        {label:'Issued date',key:'ISSUE_DATE',type:"date",split:false},
        {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false}
      ],
      SBOOK:[
        {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
        {label:'Type',key:'DOCTYPE_NAME',type:"string",split:false},
        {label:"Seaman's document type",key:'SUB_TYPE_NAME',type:"string",split:false},
        {label:'Document number',key:'DOC_NO',type:"string",split:false, errorType:'maxlength',maxLength:25},
        {label:'Issued country',key:'COUNTRY_NAME',type:"string",split:false},
        {label:'Issued date',key:'ISSUE_DATE',type:"date",split:false},
        {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false,exclude:['NO_EXPIRY']}
      ],
      VISA:[
        {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
        {label:'Type',key:'DOCTYPE_NAME',type:"string",split:false},
        {label:'Visa type',key:'SUB_TYPE_NAME',type:"string",split:false},
        {label:'Visa entry',key:'COMMENTS',type:"string",split:true,postion:0,exclude:['VISA-C1/D','VISA-B1/B2','OTHER']},
        {label:'Visa duration',key:'COMMENTS',type:"string",split:true,postion:1,exclude:['VISA-C1/D','VISA-B1/B2','OTHER']},
        {label:'Visa number',key:'DOC_NO',type:"string",split:false, errorType:'maxlength',maxLength:25},
        {label:'Visa country',key:'COUNTRY_NAME',type:"string",split:false},
        {label:'Issued country',key:'VISADOC_COUNTRY_NAME',type:"string",split:false},
        {label:'Issued date',key:'ISSUE_DATE',type:"date",split:false},
        {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false,exclude:['NO_EXPIRY']},
      ],
      VACC:[
        {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
        {label:'Type',key:'DOCTYPE_NAME',type:"string",split:false},
        {label:"Vaccination type",key:'SUB_TYPE_NAME',type:"string",split:false},
        {label:'Comment',key:'COMMENTS',type:"string",split:false,exclude:['VACCYF']},
        {label:'Issued date',key:'ISSUE_DATE',type:"date",split:false},
        {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false,exclude:['NO_EXPIRY']}
      ],
  },
  MEDICAL:{
    PREEMPL:[
      {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
      {label:'Type',key:'DOCTYPE_NAME',type:"string",split:false},
      {label:'Fit/Unfit',key:'COMMENTS',type:"string",split:true,postion:0},
      {label:'Issued date',key:'ISSUE_DATE',type:"date",split:false},
      {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false},
      {label:'Comment',key:'COMMENTS',type:"string",split:true,postion:1},
    ],
    DRUGALCO:[
      {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
      {label:'Type',key:'DOCTYPE_NAME',type:"string",split:false},
      {label:'Positve Negative',key:'COMMENTS',type:"string",split:true,postion:0},
      {label:'Issued date',key:'ISSUE_DATE',type:"date",split:false},
      {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false}
    ],
    SUPPMED:[
      {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
      {label:'Type',key:'DOCTYPE_NAME',type:"string",split:false},
      {label:'Fit/Unfit',key:'COMMENTS',type:"string",split:true,postion:0},
      {label:'Issued date',key:'ISSUE_DATE',type:"date",split:false},
      {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false},
      {label:'Comment',key:'COMMENTS',type:"string",split:true,postion:1}
    ]
  },
  LICENSES: [
    {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
    {label:'Name/Code',key:'DOCTYPE_NAME',type:"string",split:false},
    {label:'Number',key:'DOC_NO',type:"string",split:false, errorType:'maxlength',maxLength:25},
    {label:'Issued at',key:'ISSUE_AT_NAME',type:"string",split:false},
    {label:'Issued by',key:'ISSUE_BY',type:"string",split:false},
    {label:'Issued date',key:'ISSUE_DATE',type:"date",split:false},
    {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false,exclude:['NO_EXPIRY']},
  ],
  FLAGSTATE: [
    {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
    {label:'Name/Code',key:'DOCTYPE_NAME',type:"string",split:false},
    {label:'Number',key:'DOC_NO',type:"string",split:false, errorType:'maxlength',maxLength:25},
    {label:'Issued at',key:'ISSUE_AT_NAME',type:"string",split:false},
    {label:'Issued by',key:'ISSUE_BY',type:"string",split:false},
    {label:'Issued date',key:'ISSUE_DATE',type:"date",split:false},
    {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false,exclude:['NO_EXPIRY']},
  ],
  TRAINING: [
    {label:'Category',key:'CATEGORY_NAME',type:"string",split:false},
    {label:'Name/Code',key:'DOCTYPE_NAME',type:"string",split:false},
    {label:'Number',key:'DOC_NO',type:"string",split:false, errorType:'maxlength',maxLength:25},
    {label:'Start date',key:'START_DATE',type:"date",split:false},
    {label:'End date',key:'END_DATE',type:"date",split:false},
    {label:'Expiry date',key:'EXPIRE_DATE',type:"date",split:false,exclude:['NO_EXPIRY']},
    {label:'Internal or external',key:'INTERNAL_NAME',type:"string",split:false},
    {label:'Conducted at',key:'CONDUCT_NAME',type:"string",split:false},
  ]
});

// Define the EXPENSE_FIELDS constant with the appropriate type


export const ADD_EXPENSE_FIELDS: any = {
  SIGN_ON_OFF: {
    PUBLIC_TRANSPORTATION:[
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child"},
      { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
      { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'},
    ],
    RENTAL_CAR:[
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
       { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
      { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    MILEAGE_PRIVATE_CAR:[
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
       { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Kilometers', required: false, key: 'KILOMETER', type: "string",errorType:'4-on-2-decimal',pattern:"^[0-9]{0,4}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
      { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: false, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
      { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
      ],
    TRANSPORTATION:[
        { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
         { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
        { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
        { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
        { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
        { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
        { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
        { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
        { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
       { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
      ],
    VISA_FEE:[
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
         { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
        { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
        { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
       { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
        { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
        { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
        { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
        { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
       { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
      ],
    ADDITIONAL_VISA_COSTS:[
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
       { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
      { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
      { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
      ],
    TRAVELLING_ALLOWANCE:[
    { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
     { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
    { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
    { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
    { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
    { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
    { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
    { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
    { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
    { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    FAMILY_TRAVEL_ALLOWANCE:[
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
       { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    ACCOMMODATION:[
      { label: 'Ship', required: true, key: 'SHIP',type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Accommodation days', required: true, key: 'ACCCOM_DAYS', errorType:'percentage', type: "string", pattern:"^[0-9]{0,3}$"},
       { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    MEALS:[
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
       { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
  },
  MEDICAL_SAFETY: {
    PUBLIC_TRANSPORTATION: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    MILEAGE_PRIVATE_CAR: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Kilometers', required: false, key: 'KILOMETER', type: "string",errorType:'4-on-2-decimal',pattern:"^[0-9]{0,4}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
      { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    RENTAL_CAR: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    ANNUAL_MEDICAL: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    DA: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    BLOOD_TEST: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    TRANSPORTATION: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    VACCINATION: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    SAFETY_SHOES: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ]
  },
  MEDICAL_CLAIM: {
    MEDICAL_CLAIM_REIMBURSEMENT: [
      { label: 'Ship', required: true, key: 'SHIP', type: "select-child",displayKey: 'SHIP_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Injury', required: false,key: 'INJURY', type: "string",maxLength:'15',errorType:'special',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Injury date',required: false, key: 'INJURY_DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
  },
  TRAINING: {
    MEALS: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    PUBLIC_TRANSPORTATION: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    MILEAGE_PRIVATE_CAR: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Kilometers', required: false, key: 'KILOMETER', type: "string",errorType:'4-on-2-decimal',pattern:"^[0-9]{0,4}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
      { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
      { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    RENTAL_CAR: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
       { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    ACCOMMODATION: [
      { label: 'Accommodation days', required: true, key: 'ACCCOM_DAYS', errorType:'percentage', type: "string", pattern:"^[0-9]{0,3}$"},
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
      { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    VISA_FEE: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    EXAMINATION_FEE: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    TRAVELLING_ALLOWANCE: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    TRANSPORTATION: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    ADDITIONAL_VISA_COSTS: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}
    ],
    FAMILY_TRAVEL_ALLOWANCE: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    TRAINING_ALLOWANCE: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    VACCINATION: [
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ],
    TRAINING_COURSE_FEE: [
      { label: 'Training course', required: true, key: 'TRAINING_COURSE_FEE',type: "select-child",displayKey: 'TRAINING_COURSE_FEE_NAME' },
      { label: 'Date of voucher', required: true, key: 'DATE', type: "date",pattern:/^(0[1-9]|[12]\d|3[01])\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/},
      { label: 'Voucher name/ no.', required: false, key: 'VOUCHER_NAME', errorType:'special', type: "string",maxLength:'15',pattern:"^[a-zA-Z0-9 ]*$"},
      { label: 'Local currency', required: true, key: 'LOCAL_CURRENCY', type: "select-child" },
     { label: 'Amount in local currency',required: true,key:'AMOUNT', errorType:'percentage',type:"string", helperText:"The max amount limit is",pattern:"^[0-9]{0,10}(([\\.]{1}[0-9]{0,2})|())$"},
      { label: 'Amount in USD', required: false, key: 'AMOUNT_IN_USD', type: "label-string"},
      { label: 'Maximum amount in USD', required: false, key: 'MAX_AMOUNT_IN_USD', type: "label-string"},
      { label: 'Upload document(s)', required: true, key: 'FILES', type: "upload"},
      { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
     { label: 'Description of expense', required: true, key: 'DESCRIPTION', type: "textarea",maxLength:'150'}

    ]
  }

};


export const REQUESTED_CASH_FIELDS = Object.freeze({
  RE_JOINING_BONUS: [
    { label: 'Type',required: true, key: 'TYPE_CODE', type: "label-string",size:'4',value:'Rejoining bonus'},
    { label: 'Beneficiary',required: true, dropdownKey:"BENEFICIARY", key: 'BENEFICIARY_ID', type: "dropdown",size:'6'},
    { label: 'Amount (USD)',required: true, key: 'AMOUNT', type: "string",size:'3',pattern:"^(\\d{1,5})(\\.\\d{1,2})?$",errorType:'max'},
  ],
  CASH_ADVANCE: [
    { label: 'Type',required: true, key: 'TYPE_CODE', type: "label-string",size:'4',value:'Cash advance'},
    { label: 'Beneficiary',required: true, dropdownKey:"BENEFICIARY", key: 'BENEFICIARY_ID', type: "dropdown",size:'6'},
    { label: 'Amount (USD)',required: true, key: 'AMOUNT', type: "string",size:'3',pattern:"^(\\d{1,5})(\\.\\d{1,2})?$",errorType:'max'},
  ],
  RE_JOINING_CASH_ADVANCE: [
    { label: 'Type',required: true, dropdownKey:"TYPE", key: 'TYPE_CODE', type: "dropdown",size:'4'},
    { label: 'Beneficiary',required: true, dropdownKey:"BENEFICIARY", key: 'BENEFICIARY_ID', type: "dropdown",size:'6'},
    { label: 'Amount (USD)',required: true, key: 'AMOUNT', type: "string",size:'3',pattern:"^(\\d{1,5})(\\.\\d{1,2})?$",errorType:'max'},
  ],
  ONBOARD_CASH_ADVANCE: [
    { label: 'Type',required: true, dropdownKey:"TYPE", key: 'TYPE_CODE', type: "label-string",value:'Onboard cash advance'},
    { label: 'Currency',required: true, dropdownKey:"CURRENCY", key: 'CURRENCY', type: "dropdown",size:'3'},
    { label: 'Amount',required: true, key: 'AMOUNT', type: "string",size:'3',pattern:"^(\\d{1,5})(\\.\\d{1,2})?$",errorType:'decimal'},
    { label: 'Balance of wage',required: true, key: 'AMOUNT_BOW', type: "label-string",size:'3',pattern:"^(\\d{1,7})(\\.\\d{1,2})?$", errorType:'decimal', value:''},
    { label: 'Reason for exceeding amount', required: false, key: 'REASON_FOR_EXCEEDING', type: "textarea",maxLength:'250'},
  ],
});

export const ADD_FEEDBACK_SURVEY_FIELDS: any = {
  SATISFACTION_SCALE: {
    QUESTION: [
      { label: 'Icon1',required: false, key: 'ICON1', type: "image", split: false},
      { label: 'Icon2',required: false, key: 'ICON2', type: "image", split: false},
      { label: 'Icon3',required: false, key: 'ICON3', type: "image", split: false},
      { label: 'Icon4',required: false, key: 'ICON4', type: "image", split: false},
      { label: 'Icon5',required: false, key: 'ICON5', type: "image", split: false},
    ]
  },
  AGREE_DISAGREE_SCALE: {
    QUESTION: [
      { label: 'Option 1',required: false, key: 'OPTIONA', type: "string", split: false,maxLength:'25' ,errorType:'special'},
      { label: 'Option 2',required: false, key: 'OPTIONB', type: "string", split: false,maxLength:'25' ,errorType:'special'},
      { label: 'Option 3',required: false, key: 'OPTIONC', type: "string", split: false,maxLength:'25' ,errorType:'special'},
      { label: 'Option 4',required: false, key: 'OPTIOND', type: "string", split: false,maxLength:'25' ,errorType:'special'},
      { label: 'Option 5',required: false, key: 'OPTIONE', type: "string", split: false,maxLength:'25', errorType:'special'},
    ]
  },
  SINGLE_CHOICE: {
    QUESTION: [
      { label: 'Yes',required: false, key: 'YES', type: "switch", split: false },
      { label: 'No',required: false, key: 'NO', type: "switch", split: false},
    ]
  },
  FREE_TEXT: {
    QUESTION: [
    ]
  },
  FREE_TEXT_SUGGESTION: {
    QUESTION: [
    ]
  }
  
}; 
export const EXPENSE_TYPE_LIST = Object.freeze([
  { id: 'Payment to contractor',  name: 'Payment to contractor'},
  { id: 'Provision', name: 'Provision',  },
  { id: 'Spare part', name: 'Spare part',  },
  { id: 'Other', name: 'Other',  },
]);

export const PAYMENT_METHODS = Object.freeze([
  { id: 'Cash',  name: 'Cash'},
  { id: 'Credit card', name: 'Credit card',  },
]);

export const CURRENCY_DATA = Object.freeze([
  {
    'id': "USD",
    'name': "USD"
  },
  {
    'id': "EUR",
    'name': "EUR"
  },
  {
    'id': "GBP",
    'name': "GBP"
  },
]);
export const CAM_EXPENSE_LIMIT = Object.freeze({
  CAM_EXPENSE_AUTO_APPROVAL_LIMIT:500
});
export const CAMHospitality_PURPOSE = Object.freeze([
  { id: 'Crew welfare',  name: 'Crew welfare'},
  { id: 'Gift', name: 'Gift'},
  { id: 'Hospitality', name: 'Hospitality'},
]);

export const CAMHospitality_DESCRIPTION = Object.freeze([
  { id: 'Beer',  name: 'Beer'},
  { id: 'Snacks',  name: 'Snacks'},
  { id: 'Soft drinks', name: 'Soft drinks'},
  { id: 'Sweets', name: 'Sweets'},
  { id: 'Water', name: 'Water'},
  { id: 'Wine',  name: 'Wine'},
  { id: 'Other', name: 'Other'},
]);
export const CAMHospitality_UNITS = Object.freeze([
  { id: 'Bottles',  name: 'Bottles'},
  { id: 'Cartons', name: 'Cartons'},
  { id: 'Cases', name: 'Cases'},
  { id: 'Pcs', name: 'Pcs'},
  { id: 'Other', name: 'Other'},
]);

export const CAMHospitality_ACCOUNT_OF = Object.freeze([
  { id: 'Charterer',  name: 'Charterer'},
  { id: 'Owner', name: 'Owner'}
]);
